// extracted by mini-css-extract-plugin
export default {"adminName":"ChangePasswordModal_adminName__dH0Xk","adminInfo":"ChangePasswordModal_adminInfo__S1e0z","tag":"ChangePasswordModal_tag__eo2xv"};